import ColumnDefinition from '../ColumnDefinition.js';
import ContextMenuDefinition from '../ContextMenuDefinition.js';
import { getCurrencySymbol } from 'utils/currency';
import { apply, parse } from '@sellsy/numberformat';

const TYPE_CONFIG = {
    purInvoice: { label: 'Facture', color: 'teal' },
    purCreditNote: { label: 'Avoir', color: 'purple' },
};

export default {
    defaultSort: { field: 'created_at', direction: 'desc' },
    columns: [
        new ColumnDefinition('file_name', window.i18n.__('Document'), false, false, (fileName, row) => ({
            type: 'component',
            name: 'cell-link',
            params: {
                label: fileName,
                event: 'ocr:verify',
                eventParams: { id: row.id },
                dataBot: 'purchases-purinvoices-list_verify-invoice_click',
            },
        }), { width: 'XXL' }),
        new ColumnDefinition('created_at', window.i18n.__("Date d'entrée"), false, true, (date) =>
            window.sellsyapp.config.globalProperties.$filters.dateFormatter(date, 'SLASHED_DATE_TIME')
        , { width: 'M' }),
        new ColumnDefinition('linked_type', window.i18n.__('Type'), false, true, (linkedType) => {
            const config = TYPE_CONFIG[linkedType] || { label: 'Inconnu', color: 'gray' };
            return {
                type: 'component',
                name: 'cell-wrapper',
                params: {
                    componentName: 'compass-pill',
                    componentProps: {
                        variant: 'pastel',
                        size: 'small',
                        label: window.i18n.__(config.label),
                        color: config.color,
                    },
                },
            };
        }, { width: 'S' }),
        new ColumnDefinition('source', window.i18n.__('Source'), false, true, (source, row) => {
            if (source === 'facturx') {
                return window.i18n.__('Électronique');
            }
            if (row.linked_type === 'purInvoice') {
                return window.i18n.__('Importée');
            }
            return window.i18n.__('Importé');
        }, { width: 'M' }),
        new ColumnDefinition('state', window.i18n.__('Statut'), false, true, (state, row) => ({
            type: 'component',
            name: 'ocr-item-state',
            params: {
                state,
                id: row.id,
                errorCode: row.error_code,
                isElectronicDoc: row.source === 'facturx',
            },
        }), { width: 'M' }),
        new ColumnDefinition('supplier', window.i18n.__('Fournisseur'), false, true, (supplier) => supplier || '', { width: 'XL' }),
        new ColumnDefinition('total_excl_tax', window.i18n.__('Montant HT'), false, true, (totalExclTax, row) => {
            if (totalExclTax === null || totalExclTax === undefined) {
                return '';
            }

            const { numformat } = window.sellsyapp.config.globalProperties.$store.state.corp;
            const currencySymbol = getCurrencySymbol(row.currency) || row.currency || '';

            return apply(parse(totalExclTax), { ...numformat, currency: currencySymbol, precision: 2 }).trim();
        }, { width: 'M', alignment: 'right' }),
    ],
    filters: [],
    hooks: {
        metas: (metas) => metas,
        fetch: (data) => {
            data.filters.state = ['completed', 'error', 'pending', 'processing'];
        },
    },
    contextMenus: [
        new ContextMenuDefinition(
            'verify',
            window.i18n.__('Vérifier'),
            (row) => ({ event: 'ocr:verify', params: { id: row.id } }),
            'vuejs',
            '_parent',
            function (row) {
                return !this.metas.user_can_validate_pur_invoice || ['processing', 'pending'].includes(row.state);
            },
            'purchases-purinvoices-list_verify-invoice_row',
        ),
        new ContextMenuDefinition(
            'delete',
            window.i18n.__('Supprimer'),
            (row) => ({ event: 'ocr:delete', params: { id: row.id } }),
            'vuejs',
            '_parent',
            function (row) {
                return row.source === 'facturx' || !this.metas.user_can_validate_pur_invoice;
            },
            'purchases-purinvoices-list_delete-invoice_row',
        ),
    ],
    batchActions: [],
};
